// extracted by mini-css-extract-plugin
export default {"latexContainer":"LatexParser_latexContainer__rVkln","latexInlineContainer":"LatexParser_latexInlineContainer__yhS0L"};